import React from "react";
import { Heading } from "../../design/heading";
import { Text } from "../../design/text";
import { Card } from "../../design/card";
import { Button } from "../../design/button";

const CustodyParentingIndex: React.FC = () => {
  const nextExchange = {
    date: "Friday, May 17",
    time: "3:00 PM",
    location: "School pickup",
    with: "Jordan",
  };

  const upcomingHoliday = {
    name: "Memorial Day",
    date: "Monday, May 27",
    with: "You",
  };

  const supportSummary = {
    lastPayment: "May 1, 2025",
    nextDue: "June 1, 2025",
    amount: "$1,200",
    status: "On Time",
  };

  const parentingPlan = {
    status: "Active",
    lastUpdated: "March 3, 2025",
    docTitle: "Ellie Parenting Plan v2",
  };

  const alerts = [
    { id: 1, type: "Missed Pickup", date: "May 10", details: "No show for 5 PM handoff" },
    { id: 2, type: "Late Exchange", date: "May 12", details: "30 minutes late" },
  ];

  const actionItems = [
    { id: 1, label: "Review Parenting Plan" },
    { id: 2, label: "Upload recent exchange log" },
  ];

  return (
    <div className="py-4 space-y-6">

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <Card>
          <Heading level={5}>Next Exchange</Heading>
          <Text>{nextExchange.date} at {nextExchange.time}</Text>
          <Text className="text-sm text-gray-500">Location: {nextExchange.location}</Text>
          <Text className="text-sm text-gray-500">With: {nextExchange.with}</Text>
        </Card>

        <Card>
          <Heading level={5}>Upcoming Holiday</Heading>
          <Text>{upcomingHoliday.name} - {upcomingHoliday.date}</Text>
          <Text className="text-sm text-gray-500">Ellie is with: {upcomingHoliday.with}</Text>
        </Card>

        <Card>
          <Heading level={5}>Child Support</Heading>
          <Text>Next Due: {supportSummary.nextDue}</Text>
          <Text className="text-sm text-gray-500">Amount: {supportSummary.amount}</Text>
          <Text className="text-sm text-gray-500">Last Payment: {supportSummary.lastPayment} ({supportSummary.status})</Text>
        </Card>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Card>
          <Heading level={5}>Parenting Plan</Heading>
          <Text>{parentingPlan.docTitle}</Text>
          <Text className="text-sm text-gray-500">Status: {parentingPlan.status}</Text>
          <Text className="text-sm text-gray-500">Last Updated: {parentingPlan.lastUpdated}</Text>
          <Button className="mt-2">View Plan</Button>
        </Card>

        <Card>
          <Heading level={5}>Action Items</Heading>
          <ul className="ml-5 list-disc">
            {actionItems.map(item => (
              <li key={item.id}>{item.label}</li>
            ))}
          </ul>
        </Card>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Card>
          <Heading level={5}>Recent Alerts</Heading>
          <ul className="divide-y divide-gray-200">
            {alerts.map(alert => (
              <li key={alert.id} className="py-2">
                <Text className="font-semibold">{alert.type}</Text>
                <Text className="text-sm text-gray-500">{alert.date} – {alert.details}</Text>
              </li>
            ))}
          </ul>
        </Card>

        <Card>
          <Heading level={5}>Calendar View</Heading>
          <div className="flex items-center justify-center h-56 text-sm text-gray-400 rounded-md bg-gray-50">
            [ Calendar Component Placeholder ]
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CustodyParentingIndex;
